import { useEffect, useState } from 'react';
import { DirectionProps } from './';

export function useResponsiveDirection(breakpoint: number): DirectionProps {
  const [direction, setDirection] = useState<DirectionProps>('horizontal');

  useEffect(() => {
    function handleResize() {
      setDirection(window.innerWidth <= breakpoint ? 'vertical' : 'horizontal');
    }

    // Set the initial direction
    handleResize();

    window.addEventListener('resize', handleResize);

    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);

  return direction;
}
